import React from 'react';
import ContactForm from './ContactForm';
import Section from '../../components/ui/Section';
import SectionTitle from '../../components/ui/SectionTitle';
import FollowInfoList from './FollowInfoList';
import ContactInfoList from './ContactInfoList';

function ContactSection() {
  const tilteInfo = {
    subTitle: '',
    title: `let's contact`,
    description: ``,
  };

  return (
    <Section>
      <SectionTitle
        className="text-center mb-10 sm:mb-14 "
        tilteInfo={tilteInfo}
      />

      <FollowInfoList />

      <div className="mt-10 grid xl:grid-cols-3 gap-10 items-start">
        <ContactForm className="xl:col-span-2" />
        <ContactInfoList className="order-first xl:order-last xl:col-span-1" />
      </div>
    </Section>
  );
}

export default ContactSection;

// const mediaList = [
// 	{
// 		imageUrl: 'images/contact/social-media/linkedin.svg',
// 		title: 'Linkedin',
// 		description: 'Meet us on professionals platform.',
// 	},
// 	{
// 		imageUrl: 'images/contact/social-media/twitter.svg',
// 		title: 'Twitter',
// 		description: 'Meet us on professionals platform.',
// 	},
// 	{
// 		imageUrl: 'images/contact/social-media/whatsapp.svg',
// 		title: 'Whatsapp',
// 		description: "Ping us through whatsapp. We'll reply you ASAP",
// 	},
// 	{
// 		imageUrl: 'images/contact/social-media/googlemap.svg',
// 		title: 'Address',
// 		description: '26 March st, El Lebeni scoordinate, Faisel ,Giza, Egypt.',
// 	},
// 	{
// 		imageUrl: 'images/contact/social-media/gmail.svg',
// 		title: 'Email',
// 		description: 'Send your query at our email and get a free estimation.',
// 	},
// 	{
// 		imageUrl: 'images/contact/social-media/medium.svg',
// 		title: 'Medium',
// 		description: 'Meet us on professionals platform.',
// 	},
// 	{
// 		imageUrl: 'images/contact/social-media/devto.svg',
// 		title: 'Devto',
// 		description: 'Send your query at our email and get a free estimation.',
// 	},
// 	{
// 		imageUrl: 'images/contact/social-media/stackoverflow.svg',
// 		title: 'Stackoverflow',
// 		description: 'Send your query at our email and get a free estimation.',
// 	},
// ]
